import { Component, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

export class AlertConfig {
	title: string;

	message: string;

	closeLabel?: string | boolean;

	confirmLabel?: string | boolean;

	reverseButtons?: boolean;

	leftAlign?: boolean;

	type?: 'success' | 'warning' | 'confirm';
}

@Component({
	selector: 'ss-alert',
	templateUrl: './alert.dialog.html',
	styleUrls: ['./alert.dialog.scss'],
	imports: [MatDialogModule, MatIconModule, MatButtonModule]
})
export class AlertDialog implements OnInit {
	defaultConfig: Partial<AlertConfig> = {
		closeLabel: 'close',
		type: 'success',
		reverseButtons: false,
		leftAlign: false
	};

	data: AlertConfig = inject(MAT_DIALOG_DATA);

	ngOnInit() {
		this.data = Object.assign(this.defaultConfig, this.data);
	}

}
